
class CapDeleteAnyTransferDates {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'delete_any_transfer_dates'
}

function create(config) {
  return new CapDeleteAnyTransferDates(config)
}

export default {
  key,
  create,
}
